import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import { about } from '../../portfolio';
import TypingText from '../TypingText/TypingText';
import ScrollReveal from '../ScrollReveal/ScrollReveal';
import './About.css';

const TYPING_ROLES = [
  'PhD Applicant in Computer Science',
  'LLM & RAG Security Researcher',
  'Adversarial Evaluation',
  'Research Software Engineer',
];

const About = () => {
  const { name, role, description, highlights, resume, social, image, gender, address } =
    about;

  return (
    <div className='about center'>
      <ScrollReveal direction='scale'>
        {image && (
          <div className='about__picture'>
            <div className='about__picture-ring' />
            <img className='about__img' alt={name || 'Swati Saxena'} src={image} />
          </div>
        )}
      </ScrollReveal>

      <ScrollReveal delay={100}>
        {name && (
          <h1 className='about__me'>
            Hi, I am <span className='about__name'>{name}</span>
            <span className='about__gender'>{gender}</span>
          </h1>
        )}
      </ScrollReveal>

      <ScrollReveal delay={200}>
        {role && (
          <h2 className='about__role'>
            <TypingText texts={TYPING_ROLES} />
          </h2>
        )}
      </ScrollReveal>

      <ScrollReveal delay={300}>
        {address && (
          <div className='about__address'>
            <LocationOnIcon />
            <span>{address}</span>
          </div>
        )}
      </ScrollReveal>

      <ScrollReveal delay={400}>
        <p className='about__desc'>{description && description}</p>
      </ScrollReveal>

      {highlights?.length > 0 && (
        <ScrollReveal delay={450}>
          <ul className='about__highlights'>
            {highlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </ScrollReveal>
      )}

      <ScrollReveal delay={500}>
        <div className='about__actions'>
          <a href='#publications' className='btn btn--primary'>
            View Publications
          </a>
          {resume && (
            <a href={resume} target='_blank' rel='noreferrer'>
              <span className='btn btn--outline'>CV</span>
            </a>
          )}
          <a href='#contact' className='btn btn--outline'>
            Get In Touch
          </a>
        </div>
      </ScrollReveal>

      <ScrollReveal delay={600}>
        <div className='about__contact center'>
          {social && (
            <>
              {social.github && (
                <a
                  href={social.github}
                  aria-label='github'
                  className='link link--icon about__social'
                  target='_blank'
                  rel='noreferrer'
                >
                  <GitHubIcon />
                </a>
              )}

              {social.linkedin && (
                <a
                  href={social.linkedin}
                  aria-label='linkedin'
                  className='link link--icon about__social'
                  target='_blank'
                  rel='noreferrer'
                >
                  <LinkedInIcon />
                </a>
              )}
              {social.youtube && (
                <a
                  href={social.youtube}
                  aria-label='youtube'
                  className='link link--icon about__social'
                  target='_blank'
                  rel='noreferrer'
                >
                  <YouTubeIcon />
                </a>
              )}
            </>
          )}
        </div>
      </ScrollReveal>

      <a href='#publications' className='about__scroll-hint' aria-label='Scroll to publications'>
        <KeyboardArrowDownIcon />
      </a>
    </div>
  );
};

export default About;
